'use client';

import * as React from 'react';

/**
 * Density for vertical spacing between chat messages.
 * - `'compact'`: Reduced vertical spacing between messages.
 * - `'standard'`: Default spacing.
 * - `'comfortable'`: Increased vertical spacing between messages.
 */
import { jsx as _jsx } from "react/jsx-runtime";
const ChatDensityContext = /*#__PURE__*/React.createContext('standard');

/**
 * Provides the chat density to all descendant message components.
 * Controls vertical spacing without prop drilling.
 * @example
 * <ChatDensityProvider density="compact">
 *   <ChatMessageList />
 * </ChatDensityProvider>
 */
if (process.env.NODE_ENV !== "production") ChatDensityContext.displayName = "ChatDensityContext";
export function ChatDensityProvider(props) {
  const {
    children,
    density
  } = props;
  return /*#__PURE__*/_jsx(ChatDensityContext.Provider, {
    value: density,
    children: children
  });
}

/**
 * Returns the current chat density from the nearest {@link ChatDensityProvider}.
 * Consumed by `MessageRoot` and `MessageGroup` to apply spacing-specific ownerState.
 */
export function useChatDensity() {
  return React.useContext(ChatDensityContext);
}